/**
 * RollingState - Player is rolling on ground
 */

import BaseState from './BaseState';
import Phaser from 'phaser';

export default class RollingState extends BaseState {
    constructor() {
        super();
        this.maxSpeed = 13;
        this.acceleration = 0.012;
        this.angularSpeed = 0.18;
    }

    enter(data) {
        // Can apply a small speed boost on entry if needed
    }

    update(delta) {
        if (!this.player || this.player.isDead) return;

        const { cursors, wasd } = this.player;
        const velocity = this.sprite.body.velocity;

        // Horizontal movement
        const moveLeft = cursors.left.isDown || wasd.left.isDown;
        const moveRight = cursors.right.isDown || wasd.right.isDown;

        // Dash (if active, skip normal movement but keep magnetic pull)
        if (this.player.handleDash(moveLeft, moveRight)) {
            this.player.handleMagneticPull();
            this.applyVisualStretch(velocity);
            return;
        }

        if (moveLeft && velocity.x > -this.maxSpeed) {
            this.sprite.setAngularVelocity(-this.angularSpeed);
            this.sprite.applyForce({ x: -this.acceleration, y: 0 });
        } else if (moveRight && velocity.x < this.maxSpeed) {
            this.sprite.setAngularVelocity(this.angularSpeed);
            this.sprite.applyForce({ x: this.acceleration, y: 0 });
        } else {
            // No input, slow down angular velocity
            this.sprite.setAngularVelocity(this.sprite.body.angularVelocity * 0.95);
            
            // If stopped and grounded, go to idle
            if (Math.abs(velocity.x) < 0.5 && this.player.isGrounded) {
                this.transitionTo('idle');
                return;
            }
        }

        // Check for jump input -> Jumping
        if (this.player.checkJumpInput()) {
            this.transitionTo('jumping');
            return;
        }

        // Check if fell off platform -> Falling
        if (!this.player.isGrounded) {
            // Use coyote time - still allow jump briefly
            const canCoyoteJump = (this.scene.time.now - this.player.lastGroundedTime) < this.player.coyoteTime;
            if (!canCoyoteJump) {
                this.transitionTo('falling');
                return;
            }
        }

        // Handle magnetic pull while rolling
        this.player.handleMagneticPull();

        // Apply visual stretch based on velocity
        this.applyVisualStretch(velocity);
    }

    applyVisualStretch(velocity) {
        const stretchY = 1 + (velocity.y * 0.01);
        const stretchX = 1 - (velocity.y * 0.005);
        
        this.sprite.setScale(
            Phaser.Math.Clamp(stretchX * this.player.baseScaleX, 0.7, 1.3),
            Phaser.Math.Clamp(stretchY * this.player.baseScaleY, 0.7, 1.3)
        );
        
        if (this.player.highlight) {
            this.player.highlight.setScale(this.sprite.scaleX, this.sprite.scaleY);
        }
    }

    exit() {
        // Nothing specific
    }
}
